import styled, { css } from "styled-components";
import { ChevronLeft, ChevronRight } from "@styled-icons/boxicons-regular";

export const Container = styled.main`
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  position: relative;

  .slick-prev:before,
  .slick-next:before {
    content: "";
    display: none;
  }
`;

export const Controls = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  width: 100%;
  bottom: 40px;
  z-index: 2;
  padding: 0 72px;

  @media screen and (max-width: 768px) {
    padding: 0 24px;
    bottom: 24px;
  }
`;

export const Dot = styled.button.attrs({ type: "button" })<{ active: boolean }>`
  flex: 1;
  height: 3px;
  border-radius: 3px;
  background-color: #ffffff80;
  margin-right: 8px;
  transition: 300ms ease;

  &:last-child {
    margin-right: 0;
  }

  ${({ active }) =>
    active &&
    css`
      background-color: white;
      height: 4px;
    `}
`;

export const IconLeft = styled(ChevronLeft).attrs({ size: 64 })`
  color: white;
`;

export const IconRight = styled(ChevronRight).attrs({ size: 64 })`
  color: white;
`;

export const ButtonPrev = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  position: absolute;
  left: 0;
  top: center;
  z-index: 99;

  &.slick-disabled {
    opacity: 0.5;
  }
`;

export const ButtonNext = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  position: absolute;
  right: 0;
  top: center;
  z-index: 99;

  &.slick-disabled {
    opacity: 0.5;
  }
`;
